var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{attrs:{"classes":"catalog"}},[_c('catalog-nav'),(!_vm.isInHomeScreen)?[_c('catalog-content'),_c('catalog-back-to-top')]:_vm._e(),(_vm.isInHomeScreen)?[_c('catalog-home-landing'),_c('catalog-home-news')]:_vm._e(),_c('catalog-footer'),_c('catalog-filter-type'),_c('catalog-filter-time'),_c('catalog-filter-address')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }